import { all, call, select, put, takeEvery } from 'redux-saga/effects';
import {
  PapiBadge,
  PapiDaUserProfileBadgesList,
  PapiRequestDaUserProfileBadgesList,
  PapiRequestDaUserProfileBadgesUpdateOrder,
} from '@wix/da-papi-types';
import {
  takeStreamFetch,
  fetchStreamContents,
} from '@wix/da-shared-react/pkg/Stream/helpers';
import { selectors, actions } from '@wix/da-shared-react/pkg/Stream';
import { request } from '@wix/da-shared-react/pkg/xhr';
import {
  fetchMoreBadges,
  moveBadgeCommit,
  moveBadgeInStream,
  refreshBadgeModules,
} from '../actions/badges';
import { API_BASE_PATH } from '../../constants';
import { BADGES_STREAM } from '../streams';
import { findModules } from '../selectors/modules';
import { ModuleType } from '../../types/modules';
import { updateModule } from '../actions/modules';
import { BADGE_COUNT } from '../components/UserWidgets/BadgesSpotlight/constants';

function* handleFetchBadges(action: ReturnType<typeof fetchMoreBadges>) {
  const { streamId } = action.payload;
  yield fetchStreamContents<
    PapiRequestDaUserProfileBadgesList,
    PapiDaUserProfileBadgesList
  >({
    streamId,
    baseURL: API_BASE_PATH,
    url: '/badges/list',
    params: {},
    getStreamData: result => ({
      hasMore: false,
      items: result.results,
    }),
  });
}

function* handleMoveBadgeInStream(
  action: ReturnType<typeof moveBadgeInStream>
) {
  const { badgeId, position } = action.payload;
  const items: PapiBadge[] = yield select(selectors.getItems, BADGES_STREAM);
  const item = items.find(i => i.id === badgeId);
  if (!item) {
    return;
  }
  yield put(actions.moveItem({ streamId: BADGES_STREAM, item, position }));
}

function* handleMoveBadgeCommit(action: ReturnType<typeof moveBadgeCommit>) {
  const { badgeId, initialPosition } = action.payload;
  const items: PapiBadge[] = yield select(selectors.getItems, BADGES_STREAM);
  const newPosition = items.findIndex(i => i.id === badgeId);
  if (newPosition < 0 || newPosition === initialPosition || newPosition > 4) {
    return;
  }
  const data: PapiRequestDaUserProfileBadgesUpdateOrder = {
    badgeid: badgeId,
    position: newPosition,
  };
  yield call(request, {
    baseURL: API_BASE_PATH,
    method: 'post',
    url: '/badges/update_order',
    data,
  });
}

function* handleRefreshBadgeModules(action) {
  const items: PapiBadge[] = yield select(selectors.getItems, BADGES_STREAM);
  if (items.length === 0) {
    return;
  }
  const slicedBadges = items.slice(0, BADGE_COUNT);
  const modules = yield select(findModules, m =>
    [ModuleType.ABOUT, ModuleType.BADGES_SPOTLIGHT].includes(m.type)
  );
  const updateActions = modules.map(m =>
    put(
      updateModule({
        id: m.id,
        moduleData: {
          ...m.moduleData,
          badges: m.type === ModuleType.BADGES_SPOTLIGHT ? slicedBadges : items,
        },
      })
    )
  );
  yield all(updateActions);
}

export default function* rootBadgesSaga() {
  yield all([
    takeStreamFetch(fetchMoreBadges, handleFetchBadges),
    takeEvery(moveBadgeInStream, handleMoveBadgeInStream),
    takeEvery(moveBadgeCommit, handleMoveBadgeCommit),
    takeEvery(refreshBadgeModules, handleRefreshBadgeModules),
  ]);
}
